import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DialMark } from './Icon.js';
import { askOrchestrator, getPrompts } from './orchestratorBus.js';
/**
 * Registry-driven "Ask the Orchestrator" prompt chips (D-123 follow-on). When the app shell has
 * injected the curated per-module prompts (setModulePrompts on the orchestrator bus), a screen's chip
 * row renders those texts, each driving the live Column-3 Orchestrator. When nothing was injected
 * (the hosted no-login preview), the given fallback renders instead, so the demo screens keep their
 * built-in chips and tab choreography untouched.
 */
export function OrcChips({ slug, className = 'chip', size = 14, fallback = null }) {
    const prompts = getPrompts(slug);
    if (!prompts)
        return fallback;
    return (_jsx(_Fragment, { children: prompts.map((p) => (_jsxs("button", { className: className, onClick: () => askOrchestrator(p), children: [_jsx(DialMark, { size: size }), " ", p] }, p))) }));
}
//# sourceMappingURL=OrcChips.js.map